import MxCImageCarousel from "@rf-l1/cards/property/property-elements-card/MxCImageCarousel";
import { usePropertyDetailPage } from "../context/PropertyDetailPageContext";
import { Box, IconButton, styled } from "@mui/material";
import MxImageBlur from "@rf-l1/images/MxImageBlur";
import { useState } from "react";
import ShareIcon from "@icons-rf/property-panel/share-black.svg?react";
import MenuSocial from "@/src-refactor/modules/shared/components/menu-social/MenuSocial";
import useCopyToClipboard from "@/shared/hooks/use-copy-to-clipboard";
import toast from "react-hot-toast";
import FsLightbox from "fslightbox-react";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";

const PropertyImagesCarrusel = () => {
  const { images, id, businessType, propertyType, sector, city, status } =
    usePropertyDetailPage();
  const [value, copy, notification] = useCopyToClipboard();
  const [toggler, setToggler] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!images) return null;

  const handleCopyOnClick = () => {
    copy(id.toString())
      .then(() => toast.success("Copiado al portapapeles"))
      .catch(() => toast.error("Error al copiar"));
  };

  const isActiveProperty = status?.id === C_PROPERTIES_STATUS.ACTIVE.id;

  const onOpenMenuNetworks = () => {
    document.getElementById("menu-social-item")?.click();
  };

  const handleImageClick = (index: number) => {
    setSelectedIndex(index);
    setToggler(!toggler);
  };

  const location = sector && city ? `${sector}, ${city}` : sector || city || "";

  return (
    <Box position="relative">
      <MxCImageCarousel
        images={images}
        renderItem={(image, index) => (
          <Box
            key={index}
            onClick={() => handleImageClick(index)}
            sx={{ cursor: "pointer" }}
          >
            <MxImageBlur
              width="100%"
              height={{
                xs: "350px",
                md: "450px"
              }}
              src={image}
              alt={image}
              objectFit="cover"
              borderRadius={1}
            />
          </Box>
        )}
      />

      {isActiveProperty && (
        <ShareButton size="small" disableRipple onClick={onOpenMenuNetworks}>
          <ShareIcon />
        </ShareButton>
      )}

      <MenuNetworks>
        <MenuSocial
          bussinesType={businessType || ""}
          propertyId={id?.toString()}
          propertyType={propertyType || ""}
          sector={location}
        >
          <div id="menu-social-item"></div>
        </MenuSocial>
      </MenuNetworks>

      <IdIcon onClick={handleCopyOnClick}>ID: {id}</IdIcon>

      <FsLightbox
        toggler={toggler}
        sourceIndex={selectedIndex}
        sources={images.map((item, index) => (
          <img src={item} key={index} alt={`Imagen ${index + 1}`} />
        ))}
      />
    </Box>
  );
};

const prefixStylesButton = `
  width: 35px;
  height: 35px;
  position: absolute;
  background: #FFFFFF;
  cursor: pointer;
  z-index: 1100;
  svg {
    color: var(--m-color-blue-03);
    fill: var(--m-color-blue-03);
    width: 25px;
    height: 25px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShareButton = styled(IconButton)`
  ${prefixStylesButton}
  top: 10px;
  right: 10px;
  padding-left: 0.9px;
`;

const IdIcon = styled(Box)`
  background: var(--color-blue-main);
  position: absolute;
  cursor: pointer;
  bottom: 0px;
  right: 0px;
  padding-left: 20px;
  padding-right: 15px;
  color: white;
  letter-spacing: 1px;
  border-radius: 0.9375rem 0 0 0;
  font-family: var(--ff-inter);
  font-weight: 600;
  font-size: 0.9375rem;
  height: 35px;
  display: flex;
  align-items: center;
  z-index: 1100;
`;

const MenuNetworks = styled(Box)`
  position: absolute;
  top: 35px;
  right: 5px;
  padding-left: 0.9px;
`;

export default PropertyImagesCarrusel;
